import { Box, CircularProgress, Typography } from "@mui/material";

import { brand } from "../../../theme/theme";

/** Spinner inside a button: pink, so it shows on the grey of a disabled button. */
export function ButtonSpinner({ size = 16 }) {
  return <CircularProgress size={size} thickness={5} sx={{ color: brand.pink }} />;
}

/** Note under the buttons while a slow action runs (bundle.social can take a few seconds). */
export function BusyNote({ message }) {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.25,
        p: 1.5,
        borderRadius: "10px",
        border: `1px solid ${brand.softBorder}`,
        backgroundColor: brand.soft,
      }}
    >
      <ButtonSpinner size={18} />
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontSize: "0.8125rem", fontWeight: 700, color: brand.pinkDark }}>{message}</Typography>
        <Typography sx={{ fontSize: "0.75rem", color: "#6B7280" }}>
          Espera unos segundos y no abandones esta página.
        </Typography>
      </Box>
    </Box>
  );
}
